<template>
    <div ref="fristhome">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>系统单车多险种</el-breadcrumb-item>

        </el-breadcrumb>
        <el-card class="box-card" style="margin-top:20px" >
            <el-form
                    :inline="true"
                    :model="searchForm"
                    :rules="searchRules"
                    ref="searchForRef"
                    autocomplete="on"
                    size="mini">
                <dl class="sysDl" >
                    <dt >
                        <h5 >其他渠道保险～建档</h5>
                        <p style="display:flex;flex-direction: row;align-items: center;padding: 10px;">
                            <el-form-item>
                                <el-button   @click.native="addData">单车多险种</el-button>
                            </el-form-item>
<!--                            <el-form-item>-->
<!--                                <el-button   @click.native="addByProduct">单险种多车</el-button>-->
<!--                            </el-form-item>-->
                        </p>
                    </dt>
                    <dd class="sysDd">
                        <h5  >系统内保险</h5>
                        <p class="sysP">
<!--                            <el-form-item>-->
<!--                                <el-button  type="primary"  @click.native="addSysCar">系统单车多险种</el-button>-->
<!--                            </el-form-item>-->
                            <el-form-item>
                                <el-button  @click.native="addSysProduct">系统单险种多车</el-button>
                            </el-form-item>
                        </p>
                        <div class="sysdiv">
                          <p style="font-weight: bold"> 订单提交时间：</p>
                          <p style="font-size: 15px;margin-top: 10px">工作日8-16点</p>
                        </div>
                    </dd>
                  <dd style="margin-left: 50px;width: 30%;">
                    <p style="display:inline-flex;flex-direction: row;align-items: center;padding: 10px; margin-right: 20px">保险顾问：{{link_name}} {{link_tel}}</p>
                    <p style="display:inline-flex;flex-direction: row;align-items: center;padding: 10px;">监督服务：{{contact_name}} {{contact_mobile}}</p>
                  </dd>
                </dl>

            </el-form>
            <el-form label-width="120px" :inline="true" size="mini"
                     :model="addForm"
                     ref="addForm"
                     :rules="rules">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="基本信息" name="first">

                        <el-row :gutter="24">
                            <el-col :span="8">
                                <el-form-item label="主车牌号" >
                                    <el-input style="width: 180px;" v-model="addForm.plate_number" prefix-icon="el-icon-search" @click.native.prevent="chooseCar"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="主车辆类型" prop="vehicle_type">
                                    <el-input style="width: 180px;" v-model="addForm.vehicle_type"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="车架号" prop="remark">
                                    <el-input style="width: 180px;" v-model="addForm.vin"/>
                                </el-form-item>
                            </el-col>

                        </el-row>
                        <el-row :gutter="24">
                            <el-col :span="8">
                                <el-form-item label="挂车车牌号" >
                                    <el-input style="width: 180px;" v-model="addForm.trailer_plate_number" prefix-icon="el-icon-search" @click.native.prevent="chooseCar"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="挂车车型" prop="vehicle_type">
                                    <el-input style="width: 180px;" v-model="addForm.trailer_vehicle_type"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="备注" prop="remark">
                                    <el-input style="width: 180px;" v-model="addForm.remark"/>
                                </el-form-item>
                            </el-col>

                        </el-row>
                        <el-row :gutter="24">
                            <el-col :span="8">
                                <el-form-item label="投保人" prop="toubao_name">
                                    <el-input style="width: 180px;" v-model="addForm.toubao_name"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="投保人证件号码" prop="toubao_idcard">
                                    <el-input style="width: 180px;" v-model="addForm.toubao_idcard"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="投保人电话" >
                                    <el-input style="width: 180px;" v-model="addForm.toubao_mobile"/>
                                </el-form-item>
                            </el-col>

                        </el-row>
                        <el-row :gutter="24">
                            <el-col :span="8">
                                <el-form-item label="被保险人" >
                                    <el-input style="width: 180px;" v-model="addForm.owner_name"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="被保险人证件号码" prop="owner_idcard">
                                    <el-input style="width: 180px;" v-model="addForm.owner_idcard"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="被保险人电话" prop="owner_mobile">
                                    <el-input style="width: 180px;" v-model="addForm.owner_mobile"/>
                                </el-form-item>
                            </el-col>

                        </el-row>
                        <el-row :gutter="24">
                            <el-col :span="24">
                                <div class="table_box">
                                    <div style="text-align: left;padding:10px 0;">
                                        <el-button type="primary" size="mini" @click="addItem">新增保险产品</el-button>
                                    </div>
                                    <el-table :data="list" border  size="mini" :summary-method="getSummaries" show-summary style="width: 100%;" stripe >
                                        <el-table-column prop="product_id" min-width="6%" label="保险产品名称" align='center' >
                                            <template slot-scope="scope">
                                                <span v-if="!scope.row.isEgdit">{{scope.row.product_name}}</span>
                                                <el-input  size="mini" prefix-icon="el-icon-search" @click.native.prevent="chooseProduct(scope.$index)" v-if="scope.row.isEgdit" v-model="scope.row.product_name"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column min-width="8%" label="保司" align='center'>
                                            <template slot-scope="scope">
                                                <span v-if="!scope.row.isEgdit">{{scope.row.corp_name}}</span>
                                                <el-input size="mini" v-if="scope.row.isEgdit" v-model="scope.row.corp_name"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column min-width="8%" prop="real_price" label="保费" align='center'>
                                            <template slot-scope="scope">
                                                <span v-if="!scope.row.isEgdit">{{scope.row.real_price}}</span>
                                                <el-input size="mini" v-if="scope.row.isEgdit" v-model="scope.row.real_price"></el-input>
                                            </template>
                                        </el-table-column>

                                        <el-table-column min-width="8%" prop="sell_price" label="净费" align='center'>
                                            <template slot-scope="scope">
                                                <span v-if="!scope.row.isEgdit">{{scope.row.sell_price}}</span>
                                                <el-input size="mini" v-if="scope.row.isEgdit" v-model="scope.row.sell_price"></el-input>
                                            </template>
                                        </el-table-column>
                                      <el-table-column label="告知" min-width="8%" :show-overflow-tooltip='true' align='center'>
                                        <template slot-scope="scope">
                                          <span @click="readNotice(scope.row)" style="color: #ff0000">投保告知</span>
                                        </template>
                                      </el-table-column>
                                        <el-table-column min-width="8%" prop="image" label="图片" align='center'>
                                          <template slot-scope="scope">
                                            <!--
                                            <span v-if="scope.row.image== null">暂无</span>
                                            <img v-else @click="openWin(scope.row.image)"
                                                 :src="scope.row.image" min-width="20" height="20"/>-->
                                            <span v-if="scope.row.image== null">暂无</span>
                                            <viewer v-if="scope.row.image">
                                            <span>
                                              <img :src="scope.row.image" min-width="20" height="20"/>
                                            </span>
                                            </viewer>
                                          </template>
                                        </el-table-column>
                                        <el-table-column min-width="8%"  prop="order_date" label="投保日期" align='center'>
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.isEgdit">{{scope.row.effective_date}}</span>

                                                <el-date-picker
                                                        size="mini"
                                                        style="width: 150px;"
                                                        value-format="yyyy-MM-dd"
                                                        v-if="!scope.row.isEgdit"
                                                        v-model="scope.row.effective_date"
                                                        type="date"
                                                        placeholder="选择投保日期">
                                                </el-date-picker>
                                            </template>
                                        </el-table-column>
                                        <el-table-column min-width="8%"  prop="start_date"  label="保险起期" align='center'>
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.isEgdit">{{scope.row.start_time}}</span>
                                                <el-date-picker
                                                        @change="startDateChange($event,scope.$index)"
                                                        size="mini"
                                                        style="width: 150px;"
                                                        :picker-options="pickerOptions1"
                                                        value-format="yyyy-MM-dd"
                                                        v-if="!scope.row.isEgdit"
                                                        v-model="scope.row.start_time"
                                                        type="date"
                                                        placeholder="选择投保日期">
                                                </el-date-picker>
                                            </template>
                                        </el-table-column>
                                        <el-table-column min-width="8%"  prop="end_date"  label="保险止期" align='center'>
                                            <template slot-scope="scope">
                                                <span v-if="!scope.row.isEgdit">{{scope.row.end_time}}</span>
                                                <el-date-picker
                                                        size="mini"
                                                        style="width: 150px;"
                                                        value-format="yyyy-MM-dd"
                                                        v-if="scope.row.isEgdit"
                                                        v-model="scope.row.end_time"
                                                        type="date"
                                                        placeholder="选择投保日期">
                                                </el-date-picker>
                                            </template>
                                        </el-table-column>
                                      <!--
                                        <el-table-column prop="link_name" label="联系人" align='center'>
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.isEgdit">{{scope.row.link_name}}</span>
                                                <el-input size="mini" v-if="!scope.row.isEgdit" v-model="scope.row.link_name"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="link_tel" label="联系电话" align='center'>
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.isEgdit">{{scope.row.link_tel}}</span>
                                                <el-input size="mini" v-if="!scope.row.isEgdit" v-model="scope.row.link_tel"></el-input>
                                            </template>
                                        </el-table-column>
                                        -->
                                        <el-table-column prop="remark" label="备注" align='center' min-width="10%" >
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.isEgdit">{{scope.row.remark}}</span>
                                                <el-input size="mini" v-if="!scope.row.isEgdit" v-model="scope.row.remark"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="link_tel" min-width="10%"  label="保单上传" align='center' >
                                            <template slot-scope="scope">
                                                <span v-if="!scope.row.isEgdit">查看保单</span>
                                                <el-upload
                                                        drag
                                                        class="avatar-uploader"
                                                        action="#"
                                                        :auto-upload="false"
                                                        :show-file-list="false"
                                                        :on-change="(file, fileList) => {handleChange(file, fileList, scope.$index)}"
                                                        :multiple=false
                                                        :file-list="scope.row.fileList"
                                                        :limit="1"

                                                        :on-success="handleAvatarSuccess"
                                                        :before-upload="beforeAvatarUpload">
                                                    <img v-if="scope.row.file_url" :src="scope.row.file_url" class="avatar">
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                            </template>
                                        </el-table-column>
                                        <el-table-column min-width="10%"  label="操作" align='center'>
                                            <template slot-scope="scope">
                                                <el-button @click.native.prevent="deleteItem(scope.$index, list)" type="danger" size="mini" icon="el-icon-delete" circle></el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="保单文件" name="second">

                        <el-row :gutter="24">
                            <el-col :span="24">
                                <div class="upload_group">
                                    <div class="upload_list">

                                    </div>
                                </div>
                            </el-col>
                        </el-row>

                    </el-tab-pane>
                </el-tabs>

                <el-row :gutter="24">
                    <el-col style="display:flex;flex-direction: row;justify-content: flex-end;padding-top: 20px;">
                        <el-form-item>
                            <el-button @click="close">取消</el-button>
                            <el-button type="primary" @click="save('addForm')">保存</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <eCar :carVisibleProp.sync="isShowCar" v-on:eventCar="chooseCarInfo"/>
        <!---->
        <el-dialog width="60%" title="产品列表" :visible.sync="productVisible" @close="closeProduct">
            <el-form size="mini" :model="searchForm" ref="searchForm" :inline="true">
            <!--
              <el-form-item label="运输公司"  prop="shop_id">
                <el-select v-model="searchForm.shop_id"  placeholder="请选择运输公司"  @change="searchClick1">
                  <el-option v-for="(item,index) in shopList" :label="item.shop_name" :value="item.shop_id" :key="item.shop_id"></el-option>
                </el-select>
              </el-form-item>
            -->
              <el-form-item label="保险公司"  prop="corp_id">
                <el-select v-model="searchForm.corp_id" filterable clearable  placeholder="请选择运输公司"  @change="searchClick1">
                  <el-option v-for="(item,index) in corpList" :label="item.name" :value="item.id" :key="index"></el-option>
                </el-select>
              </el-form-item>

                <el-form-item label="产品名称" prop="keywords">
                    <el-input   v-model="searchForm.keywords" palceholder="请输入产品名称"></el-input>
                </el-form-item>
                <el-form-item prop="name">
                    <el-button type="primary" @click="searchClick1">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click.native="searchClick('超赔')">超赔险</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button  @click.native="searchClick('驾乘')">驾乘险</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click.native="searchClick('雇主')">雇主险</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click.native="searchClick('货物')">货物险</el-button>
                </el-form-item>
                <div>
                    <el-table :data="productMList"  border  size="mini" style="width: 100%;" stripe >
                        <el-table-column label="选择" align="center" width="55">
                            <template slot-scope="scope">
                                <el-checkbox :label="scope.$index" v-model="scope.row.checked"  @change.native="getCurrentRow(scope.row,scope.$index)" :id="'check'+scope.$index">&nbsp;</el-checkbox>
                                <!--<input type="checkbox" :v-model="scope.row.checked"  :label="scope.$index" @change="getCurrentRow(scope.row,scope.$index)"/>-->
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="title"
                                label="产品方案名称">
                        </el-table-column>
                        <el-table-column
                                prop="product.name"
                                label="产品名称">
                        </el-table-column>
                        <el-table-column
                                prop="real_price"
                                label="保费">
                        </el-table-column>
                        <el-table-column label="净费(元)" :show-overflow-tooltip='true'>
                            <template slot-scope="scope" >
                                <span v-if="scope.row.shopmd.length >0" v-for="(it,idx) in scope.row.shopmd" :key="idx">
                                 {{it.sell_price}}
                              </span>
                              <span v-if="scope.row.shopmd.length<1">
                               {{scope.row.sell_price}}
                              </span>
                            </template>

                        </el-table-column>
                        <el-table-column
                                prop="corp.name"
                                label="保险公司">
                        </el-table-column>
                        <el-table-column label="投保告知" :show-overflow-tooltip='true'>
                            <template slot-scope="scope">
                                <span @click="readNotice(scope.row)" style="color: #ff0000">投保告知</span>
                            </template>
                        </el-table-column>
                      <el-table-column  prop="image" label="图片" align='center'>
                        <template slot-scope="scope">
                          <span v-if="scope.row.image== null">暂无</span>
                          <viewer v-if="scope.row.image">
                            <span>
                              <img :src="scope.row.image" min-width="20" height="20"/>
                            </span>
                          </viewer>
                          <!--
                          <span v-if="scope.row.image== null">暂无</span>
                          <img v-else @click="openWin(scope.row.image)"
                               :src="scope.row.image" min-width="20" height="20"/>
                               -->
                        </template>
                      </el-table-column>
                      <!--
                        <el-table-column
                                label="联系人"
                                prop="contact_name"
                                :show-overflow-tooltip='true'>
                        </el-table-column>
                        <el-table-column
                                label="联系电话"
                                prop="contact_mobile"
                                :show-overflow-tooltip='true'>
                        </el-table-column>
                      -->
                    </el-table>
                  <div class="block" style="margin-top:10px" >
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNum"
                        :page-sizes="[10, 20, 30, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
                  </div>
                </div>
                <el-row>
                    <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">
                        <el-button size="mini" @click="productVisible = false;">取消</el-button><!--pIndex = -1;-->
                        <el-button  size="mini" type="primary" @click="okProduct">确定</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
        <!---->
        <el-dialog width="70%" title="投保告知" :visible.sync="noticeVisible" :close-on-click-modal="false" lock-scroll :close-on-press-escape="false"  :show-close="false">
            <div>
              {{cpys}}
                </div>
            <el-row>
                <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">
                    <el-button  size="mini" type="primary" @click="okRead">已阅读</el-button>
                </el-col>
            </el-row>
        </el-dialog>
      <!--图片放大组件-->
      <bigImg :visible.sync="isShowImg" :url="img" v-on:eventCar="chooseImgInfo"/>
    </div>
</template>
<script>
    import moment from 'moment'     //日期时间转换
    import eCar from "../common/eCar";
    import bigImg from "../common/bigImg";
    import Watermark from "../../utils/waterMark";
    export default {
        name:'eInsurance',
        props:['carVisibleProp'],
        components: {
            eCar,
            bigImg
        },
        data(){
            return {
                pickerOptions1:{
                    disabledDate(time) {
                        //return time.getTime() < Date.now() - 8.64e7;
                      return time.getTime() <= Date.now()
                    }
                },
                applicantLoading:false,
                applicantList:[],
                applicantStates:[],
                cpys:'',
                corp:'',
                corpLoading:'',
                corpList:[],
                corpStates:[],

                isShowCar:false,
                productMList:[],
                productList:[],
                productVisible:false,
                index:0,
                pIndex:-1,
                productId:[],
                options: [],
                carList: [],
                loading: false,
                states: [],

                shopList:[],
                searchForm:{
                    keywords:'',
                    shop_id:''
                },
                addForm:{
                    engine_number:'',
                    plate_number:'',
                    car_id:'',
                    shop_id:'',
                    toubao_name:'',
                    toubao_idcard:'',
                    toubao_mobile:'',
                    owner_id:"",
                    owner_idcard:"",
                    owner_mobile:"",
                    link_name:'',
                    link_tel:'',
                    remark:'',
                    vehicle_type:'',
                    trailer_vehicle_type:'',
                    vin:''
                },
                rules: {
                    applicant: [{ required: true, message: '请输入投保人', trigger: 'blur' }],
                    insured: [{ required: true, message: '请输入被投保人', trigger: 'blur' }],
                    toubao_mobile:[{ required: true, message: '请输入投保人电话', trigger: 'blur' }],

                },
                searchRules:{

                },
                title:'保单新增',
                car_number:'',
                fileList:[],
                activeName: 'first',
                insurance_date:'',
                pickerOptions: {
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                },
                list: [],
                noticeVisible:false,
                isRead:false,
                link_name:'',
                link_tel:'',
                contact_name:'',
                contact_mobile:'',
                pageSize:20,
                pageNum:1,
                total:0,
                isShowImg:false,
                img:''
            }
        },
      created() {
        this.shopList=JSON.parse(sessionStorage.getItem('shopList'));
        this.searchForm.shop_id  = this.shopList[0] ? this.shopList[0]['shop_id']:'';
        this.link_name = sessionStorage.getItem('link_name');
        this.link_tel = sessionStorage.getItem('link_tel');
        this.contact_name = sessionStorage.getItem('contact_name');
        this.contact_mobile = sessionStorage.getItem('contact_mobile');
        let str = sessionStorage.getItem('userName')+' '+moment().format("yyyy-MM-DD HH:mm:ss");
        this.corpRemoteMethod();
        this.$nextTick(() => { //要加载完才能获取$refs
          Watermark.set(str,this.$refs.fristhome)
        })
      },
        mounted() {
            this.carList = this.states.map(item => {
                return { value: `${item}`, label: `${item}` };
            });
            this.getProductList();
            this.getProductMList();
        },
        methods:{
          openWin(url) {
            //console.log('img:',url)
            this.isShowImg = true;
            this.img = url;
            //var name;                           //网页名称，可为空;
            // var iWidth = 500;                         //弹出窗口的宽度;
            //var iHeight = 570;                        //弹出窗口的高度;
            //var iTop = (window.screen.height - 30 - iHeight) / 2;       //获得窗口的垂直位置;
            //var iLeft = (window.screen.width - 10 - iWidth) / 2;        //获得窗口的水平位置;
            //window.open(url, name, 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,scrollbars=auto,resizable=no,location=no,status=no');
          },
            searchClick(val){
                this.pIndex='-1';
                this.searchForm.keywords=val;
                this.productMList=[];
                this.getProductMList();
            },
            searchClick1(){
                this.pIndex='-1';
                this.productMList=[];
                this.getProductMList();
            },
            okRead(){
                this.noticeVisible=false;
                this.isRead=true;
            },
            readNotice(row){
                this.cpys = row.cpys
                this.noticeVisible=true;
            },
            handleAvatarSuccess(){

            },
            beforeAvatarUpload(){

            },
            // 新增
            addData() {
                this.$router.push('/insuranceAdd');
            },
            addByProduct(){
                this.$router.push('/insuranceAddByProduct');
            },
            addSysProduct(){
                this.$router.push('/insuranceSysProduct');
            },
            addSysCar(){
                this.$router.push('/insuranceSysCar');
            },
            getCurrentRow(row,index){
                if(row.checked)
                {
                  //console.log('aaa',this.list)
                  if(this.list.length>0) {
                    for (var i = 0; i < this.list.length; i++) {
                      //console.log(this.list[i])
                      if (this.list[i] != "undefined" && this.list[i].product_id == row.product.id) {
                        //console.log('no')
                        this.productMList[index].checked = false;
                        this.$message.error("保险产品不能重复添加");
                        return false;
                      }
                    }}

                    this.productMList[index].checked = true
                    this.noticeVisible = true;
                    let item = {
                      id: null,
                      title: row.title,
                      product_name: row.product.name,
                      product_id: row.product.id,
                      product_md_id: row.id,
                      real_price: row.real_price,
                      price: row.price,
                      sell_price: row.shopmd[0] ? row.shopmd[0]['sell_price'] : row.sell_price,
                      effective_date: this.getDate(),
                      start_time: "",
                      end_time: '',
                      isEgdit: false,
                      corp_id: row.corp_id,
                      corp_name: row.corp.name,
                      file_url: '',
                      fileList: [],
                      remark: '',
                      image:row.image,
                      cpys:row.cpys
                    }
                    this.list.push(item);
                    //console.log('list:', this.list)
                    this.cpys = row.cpys;

                  //this.index=this.index+1;
                }else{
                  this.productMList[index].checked = false
                  this.list.forEach((lItem, Lindex)=>{
                    if(lItem.product_md_id == this.productMList[index].id)
                    {
                      this.$delete(this.list, Lindex);
                    }
                  })
                }
            },
            getProductList(){
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                    type:1
                }
                this.$axios.insuranceProdcutList(param).then(res=>{
                    if(res.code == 200){
                        this.productList = res.data.data
                    }else{
                      this.$message.error(res.msg);
                    }
                }).catch(error=>{
                    //console.log(error);
                })
            },
            getProductMList() {
                const param = {
                    company_id: 159,
                    access_token: sessionStorage.getItem('token'),
                    page:this.pageNum,
                    pageSize:this.pageSize,
                }
              if(this.searchForm.keywords) param.queryParams=this.searchForm.keywords;
              if(this.searchForm.corp_id) param.corp_id=this.searchForm.corp_id;
                this.$axios.insuranceProductMdList(param).then(res => {
                    if (res.code == 200) {
                        this.productMList = res.data.data
                        this.total = res.data.total
                        for(let key in this.productMList){
                          this.$set(this.productMList[key],'checked',false)
                        }
                      ////console.log(this.productMList);
                    }
                    else{
                      this.$message.error(res.msg);
                    }
                }).catch(error => {
                    //console.log(error);
                })
            },
            applicantRemoteMethod(query){
                if (query !== '') {
                    this.applicantLoading = true;
                    let param={
                        queryParams:query,
                        operator_id:sessionStorage.getItem('user_id'),
                        company_id:sessionStorage.getItem('company_id'),
                        access_token:sessionStorage.getItem('token'),
                    }
                    //console.log('param------',param)

                    this.$axios.shopList(param).then(res=>{
                        if(res.code == 200){
                            this.applicantStates = res.data.data;
                        }
                    }).catch(error=>{
                        //console.log(error);
                    })
                    setTimeout(() => {
                        this.applicantLoading = false;
                        this.applicantList = this.applicantSet.filter(item => { // 这里的this.list，换为this.applicantSet
                            return item.name;
                        });
                    }, 1000);
                } else {
                    this.applicantList = [];
                }
            },
            corpRemoteMethod(){
              //this.applicantLoading = true;
              let param={
                operator_id:sessionStorage.getItem('user_id'),
                company_id:159,//sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
              }
              this.$axios.corpList(param).then(res=>{
                if(res.code == 200){
                  ////console.log('1122',res.data)
                  this.corpList = res.data.data;
                }
              }).catch(error=>{
                //console.log(error);
              })
            },
            chooseCarInfo(plate_number,...params){
                this.addForm.plate_number=plate_number;
                this.addForm.car_id=params[0];

                this.addForm.vehicle_type=params[1];
                this.addForm.owner_name=params[2];
                this.addForm.toubao_name=params[2];
                this.addForm.shop_id=params[4];
                this.addForm.owner_id=params[4];
                this.addForm.owner_idcard=params[5];
                this.addForm.toubao_idcard=params[5];
                this.addForm.vin=params[3];
                this.addForm.toubao_mobile=params[6];
                this.addForm.owner_mobile=params[6];
            },
            chooseImgInfo(){
              //todo
              this.isShowImg = false;

            },
            handleClick(){

            },
            closeProduct(){

            },
            okProduct(){
                this.productVisible=false;
                //this.pIndex = -1;
            },
            chooseProduct(index){
                this.productVisible=true;
                this.index=index;
                ////console.log('list0-------',this.list)
            },
            chooseCar(){
                 this.isShowCar=true;
            },
            remoteMethod(query) {
                if (query !== '') {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.options = this.carList.filter(item => {
                            return item.name.indexOf(query) > -1;
                        });
                    }, 200);
                } else {
                    this.options = [];
                }
            },
            onClose(){
                this.$emit('close')
            },
            close(){
                this.$emit('close')
            },
            handleBeforeUpload(){

            },
            uploadSuccess(){

            },
            handleChange(file,fileList,index){
                let _this=this;

                //------上传到阿里云
                let carFd = new FormData()
                carFd.append('file', file.raw)
                carFd.append('file_type', 1)
                // carFd.append('file_value', this.addForm.vin)
                carFd.append('company_id', sessionStorage.getItem('company_id'))
                carFd.append('access_token', sessionStorage.getItem('token'))
                this.$axios.ossUploadFile(carFd).then(res11 => {

                    //console.log('aliyun--------',res11)
                    if (res11.code == 200) {
                        this.$message.success(res11.msg)
                        _this.list[index].file_url = res11.data.src;
                        //console.log('file_url--------', _this.list[index].file_url)

                    } else if (res11.code == 1) {
                        this.$message.error(res11.msg)
                    }
                }).catch(function (error) {
                    //console.log(error);
                })
                //------上传到阿里云
            },
            save(formName){
                let _this=this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var param={
                            company_id:sessionStorage.getItem('company_id'),
                            access_token:sessionStorage.getItem('token'),
                            car_id:_this.addForm.car_id,
                            type:2,
                            owner_id:this.addForm.owner_id,
                            shop_id:this.addForm.shop_id,
                            owner_name:this.addForm.owner_name,
                            owner_idcard:this.addForm.owner_idcard,
                            owner_mobile:this.addForm.owner_mobile,
                            toubao_name:this.addForm.toubao_name,
                            toubao_idcard:this.addForm.toubao_idcard,
                            toubao_mobile:this.addForm.toubao_mobile,
                            remark:this.addForm.remark,
                            vin:this.addForm.vin,
                            productList:[]
                        };
                        for (var j=0;j<this.list.length;j++){
                            var pm={
                                pay_id:0,
                                product_id:this.list[j].product_id,
                                product_md_id:this.list[j].product_md_id,
                                corp_id:this.list[j].corp_id,
                                proposal_form:'',
                                policy_no:'',
                                sell_price:this.list[j].sell_price,
                                price:this.list[j].price,
                                real_price:this.list[j].real_price,
                                remark:this.list[j].remark,
                                effective_date:this.list[j].effective_date,
                                end_time:this.list[j].end_time,
                                start_time:this.list[j].start_time,
                                account:'',
                                account_number:'',
                                file_url:this.list[j].file_url,
                                pay_remark:'',
                                pay_money:'',
                                type:'',//收款类型
                                pay_date:'',
                                payee_account:'',
                                payee_account_number:'',
                                title:this.list[j].title,
                                payee_bank_name:'',
                                account_bank_name:'',
                                big_amount:'',
                                small_amount:'',
                                bank_receipt_sn:'',
                                receipt_sn:'',
                                bank_desc:'',
                                bank_use:'',
                                bank_date:'',
                                contact_name:'',
                                contact_mobile:'',
                            };
                            param.productList.push(pm)
                        }
                        ////console.log('addForm------',param);

                        this.$axios.saveOrderBySysCar(param).then(res =>{
                          ////console.log(res)
                            if(res.code == 200){
                                //this.DataList()
                                this.$message.success(res.msg)
                                this.$router.push('/insuranceSysTeamOrder')
                                //location.reload();
                            }else{
                                this.$message.error(res.msg);
                            }
                        })
                    }
                });

            },
            dealSpace(str){
                return str.replace(/&nbsp;/gi, " ");
            },
            //合计 表格每一列需要带上prop
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '总数量';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] += '';
                    } else {
                        sums[index] = '';
                    }
                });
                return sums;
            },
            //新增数据
            addItem() {
                this.productVisible=true;
            },
            //删除数据
            deleteItem(index, list) {
                if(this.index>0){
                    this.index=this.index-1;
                }
                //console.log(index)
                list.splice(index, 1);
              //console.log(list)
            },
            //编辑数据
            edit(index, row) {
                this.$set(row, 'isEgdit', true)
            },
            //编辑成功
            editSuccess(index, row) {
                this.$set(row, 'isEgdit', false)
            },
            startDateChange(date,idx){

                this.list[idx].start_time=date;
                let tmp1=new Date(date);
                var tmp= moment(tmp1.getFullYear()+"-"+(tmp1.getMonth()+1)+'-'+tmp1.getDate()).add(1, 'y').format('YYYY-MM-DD');
                this.list[idx].end_time=moment(tmp).subtract(1, 'days').format('YYYY-MM-DD');

            },
            getNowTime(y=0,m=0,d=0) {
                var now = new Date();

                var year = now.getFullYear()+y; //得到年份
                var month = now.getMonth(); //得到月份
                var date = now.getDate()+d; //得到日期
                var hour =" 00:00:00"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
                month = month + 1+m;
                month = month.toString().padStart(2, "0");
                date = date.toString().padStart(2, "0");
                var defaultDate = `${year}-${month}-${date}${hour}`;
                //console.log(defaultDate)
                return defaultDate;
                //this.$set(this.addForm, "effective_date", defaultDate);
            },
            getDate(y=0,m=0,d=0) {
                var now = new Date();

                var year = now.getFullYear()+y; //得到年份
                var month = now.getMonth(); //得到月份
                var date = now.getDate()+d; //得到日期
                var hour =" 00:00:00"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
                month = month + 1+m;
                month = month.toString().padStart(2, "0");
                date = date.toString().padStart(2, "0");
                var defaultDate = `${year}-${month}-${date}`;
                //console.log(defaultDate)
                return defaultDate;
                //this.$set(this.addForm, "effective_date", defaultDate);
            },
          handleSizeChange(newSize){
            this.pageSize = newSize
            this.getProductMList()
          },
          handleCurrentChange(newPage){
            this.pageNum = newPage
            this.getProductMList();
          },
        },
        computed: {
            applicantSet() {
                return this.applicantStates.map(item => {
                    return { id: `${item.id}`, name: `${item.name}-${item.name}` };
                });
            },
            corpSet() {
                return this.corpStates.map(item => {
                    return { id: `${item.id}`, name: `${item.name}` };
                });
            }
        },
    }
</script>
<style lang="less" scoped>
    //https://www.yzktw.com.cn/post/1262748.html



    .upload_group {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .upload_list {
            width: 100px;
            margin-right: 1rem;

        }

        /deep/.el-upload-dragger .el-upload__text {
            font-size: 10px;
            color: #409EFF;
        }

        /deep/.el-icon-upload:before {
            width: 30px !important;
            height: 30px !important;
        }
        .upload_list:last-child {
            margin-right: 0;
        }

        /deep/.el-upload-dragger {
            width: 100%;
            height: auto;
            padding: 20px 0;
            border: 1px solid #999;
        }

        /deep/.el-upload {
            width: 100%;
        }

        /deep/.el-upload-dragger .el-icon-upload {
            margin: 10px 0;
        }
    }
    .table_name:hover{
        color: #409EFF;
        cursor: pointer;
    }

    /deep/.el-upload-dragger {
        width: 50px !important;
        height: 50px !important;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
    }
    .avatar {
        width: 50px !important;
        height: 50px !important;
        display: block;
    }

    .sysDl{
      display:flex;
      flex-direction: row;
      align-items: center;
      justify-content:flex-start;
    }
    .sysDl dt,.sysDd{
      border-radius: 5px;width: 30%;
    }
    .sysDl dt{
      background-color: #e1f3d8;
    }
    .sysDl .sysDd{
      background-color: #e6f1fe;
      margin-left: 50px;
      position: relative;
    }
    .sysDl h5{
      color: #666;padding:20px 0 0 20px;
    }
    .sysDl .sysDd .sysP,.sysDl .dt .sysP{
      display:flex;flex-direction: row;align-items: center;padding: 10px;
    }
    .sysDl .sysDd .sysdiv{
      display:flex;flex-direction:column;width: 30%;position: absolute; top:30px;left: 65%
    }
</style>



// WEBPACK FOOTER //
// src/view/insurance/insuranceSysCar.vue